<template>
  <div>
    <table style="width: 100%; border: none" v-if="rows.length">
      <thead>
      <tr>
        <th v-for="(header, index) in headers" :key="index" :style="{width: '30%'}">{{ header }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
        <td v-for="(value, valueIndex) in row" :key="valueIndex">{{ value }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'LockSummary',
  props: {
    phoneNumberLockHistories: {
      type: Array,
      required: true
    },
    phoneNumber: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      headers: ['', 'Viettel', 'Mobifone', 'Vinaphone', 'Ngoại mạng'],
      rows: []
    }
  },
  mounted () {
    this.buildHtml()
  },
  methods: {
    buildHtml () {
      // const viettelLockInfo = this.phoneNumberLockHistories.find(item => item.id === this.phoneNumber.viettel_lock_history_id)
      // const mobifoneLockInfo = this.phoneNumberLockHistories.find(item => item.id === this.phoneNumber.mobifone_lock_history_id)
      // const vinaphoneLockInfo = this.phoneNumberLockHistories.find(item => item.id === this.phoneNumber.vinaphone_lock_history_id)
      // const otherLockInfo = this.phoneNumberLockHistories.find(item => item.id === this.phoneNumber.other_lock_history_id)
      this.rows.push(['Ngày khóa gần nhất', this.phoneNumber.last_viettel_lock_date ? this.phoneNumber.last_viettel_lock_date : '', this.phoneNumber.last_mobifone_lock_date ? this.phoneNumber.last_mobifone_lock_date : '', this.phoneNumber.last_vinaphone_lock_date ? this.phoneNumber.last_vinaphone_lock_date : '', this.phoneNumber.last_other_lock_date ? this.phoneNumber.last_other_lock_date : ''])
      this.rows.push(['Ngày mở lại', this.phoneNumber.last_viettel_unlock_date ? this.phoneNumber.last_viettel_unlock_date : '', this.phoneNumber.last_mobifone_unlock_date ? this.phoneNumber.last_mobifone_unlock_date : '', this.phoneNumber.last_vinaphone_unlock_date ? this.phoneNumber.last_vinaphone_unlock_date : '', this.phoneNumber.last_other_unlock_date ? this.phoneNumber.last_other_unlock_date : ''])
      this.rows.push(['Ngày gửi NCC', this.phoneNumber.last_viettel_send_provider_date ? this.phoneNumber.last_viettel_send_provider_date : '', this.phoneNumber.last_mobifone_send_provider_date ? this.phoneNumber.last_mobifone_send_provider_date : '', this.phoneNumber.last_vinaphone_send_provider_date ? this.phoneNumber.last_vinaphone_send_provider_date : '', this.phoneNumber.last_other_send_provider_date ? this.phoneNumber.last_other_send_provider_date : ''])
      this.rows.push(['Số lần khóa', this.phoneNumber.viettel_lock_count, this.phoneNumber.mobifone_lock_count, this.phoneNumber.vinaphone_lock_count, this.phoneNumber.other_lock_count])
    }
  },
}
</script>
<style scoped>
.table-bordered th, .table-bordered td {
  border: 1px solid #dee2e675;
}
th {
  border-bottom: 1px solid #dee2e675;
}
</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/LockSummary.vue